import { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { temoignagesApi } from '../../api/contentApi';
import { Button } from '../../components/ui/Button';

const VIDE = { nom: '', entreprise: '', note: 5, contenu: '', univers: 'commun', statut: 'valide' };

export function TemoignagesManager() {
  const { data: temoignages, loading, refetch } = useFetch(() => temoignagesApi.adminList(), []);
  const [edition, setEdition] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  function ouvrirCreation() {
    setEdition({ ...VIDE });
    setErrors({});
  }

  function ouvrirEdition(t) {
    setEdition({ ...VIDE, ...t });
    setErrors({});
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setErrors({});

    try {
      if (edition.id) {
        await temoignagesApi.update(edition.id, edition);
      } else {
        await temoignagesApi.create(edition);
      }
      setEdition(null);
      refetch();
    } catch (err) {
      setErrors(err.errors || { _global: err.message });
    } finally {
      setSubmitting(false);
    }
  }

  async function moderer(id, statut) {
    await temoignagesApi.moderate(id, statut);
    refetch();
  }

  async function handleDelete(id) {
    if (!window.confirm('Supprimer ce témoignage ?')) return;
    await temoignagesApi.remove(id);
    refetch();
  }

  if (loading) return <p>Chargement...</p>;

  return (
    <section>
      <div className="admin-toolbar">
        <h1>Témoignages</h1>
        {!edition && <Button onClick={ouvrirCreation}>+ Ajouter un témoignage</Button>}
      </div>

      {edition && (
        <form className="admin-form" onSubmit={handleSubmit}>
          <div className="admin-form__field">
            <label>Nom</label>
            <input value={edition.nom} onChange={(e) => setEdition({ ...edition, nom: e.target.value })} required />
            {errors.nom && <span className="admin-form__error">{errors.nom}</span>}
          </div>

          <div className="admin-form__field">
            <label>Entreprise (optionnel)</label>
            <input value={edition.entreprise || ''} onChange={(e) => setEdition({ ...edition, entreprise: e.target.value })} />
          </div>

          <div className="admin-form__field">
            <label>Note (1 à 5)</label>
            <input
              type="number"
              min="1"
              max="5"
              value={edition.note}
              onChange={(e) => setEdition({ ...edition, note: Number(e.target.value) })}
            />
            {errors.note && <span className="admin-form__error">{errors.note}</span>}
          </div>

          <div className="admin-form__field">
            <label>Avis</label>
            <textarea rows={4} value={edition.contenu} onChange={(e) => setEdition({ ...edition, contenu: e.target.value })} required />
            {errors.contenu && <span className="admin-form__error">{errors.contenu}</span>}
          </div>

          <div className="admin-form__field">
            <label>Univers</label>
            <select value={edition.univers} onChange={(e) => setEdition({ ...edition, univers: e.target.value })}>
              <option value="commun">Commun</option>
              <option value="particulier">Particulier</option>
              <option value="professionnel">Professionnel</option>
            </select>
          </div>

          <div className="admin-form__field">
            <label>Statut</label>
            <select value={edition.statut} onChange={(e) => setEdition({ ...edition, statut: e.target.value })}>
              <option value="en_attente">En attente</option>
              <option value="valide">Validé</option>
              <option value="rejete">Rejeté</option>
            </select>
          </div>

          {errors._global && <p className="admin-form__error">{errors._global}</p>}

          <div className="admin-form__actions">
            <Button type="submit" disabled={submitting}>
              {edition.id ? 'Enregistrer' : 'Créer'}
            </Button>
            <Button type="button" variant="secondary" onClick={() => setEdition(null)}>
              Annuler
            </Button>
          </div>
        </form>
      )}

      <table className="admin-table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Note</th>
            <th>Statut</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {temoignages?.map((t) => (
            <tr key={t.id}>
              <td>{t.nom}</td>
              <td>{t.note}/5</td>
              <td>{t.statut}</td>
              <td className="admin-table__actions">
                {t.statut === 'en_attente' && (
                  <>
                    <button onClick={() => moderer(t.id, 'valide')}>Valider</button>
                    <button onClick={() => moderer(t.id, 'rejete')}>Rejeter</button>
                  </>
                )}
                <button onClick={() => ouvrirEdition(t)}>Modifier</button>
                <button onClick={() => handleDelete(t.id)}>Supprimer</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
